import {
  DiagnosticVariableCellOptionsDisplayModeType,
  DiagnosticVariableColumn,
  I4BColumn,
  I4BColumnConfiguration,
  I4BColumnHeader,
  I4BColumnOptions
} from '@iot-platform/models/grid-engine';
import { DeviceVariable } from '@iot-platform/models/i4b';
import { ProcessCellForExportParams } from 'ag-grid-community';
import { get } from 'lodash';

export type DiagnosticVariableExportType = 'datetime' | 'value' | 'unit';

export class DiagnosticVariableCellHelper {
  static getVariableNamesByGridColumns(columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[]): string[] {
    const diagnosticVariableColumns = columns.filter((col) => col.columnId === '9374044f-8451-444e-8a16-6044eec9c112-diagnostic-variable-group');
    if (!!diagnosticVariableColumns.length) {
      return diagnosticVariableColumns.reduce((acc: string[], value) => {
        acc.push(...DiagnosticVariableColumn.getVariableNamesByCategory(value.configuration.id));
        return acc;
      }, []);
    } else {
      return [];
    }
  }

  static getValueToProcessByType(params: ProcessCellForExportParams): {
    value: string;
    type: DiagnosticVariableExportType;
  } {
    const { column, node } = params;
    const cellCategory: string = get(column, 'colDef.cellRendererParams.cellOptions.variableCategory');
    const expandedVariables: { [key: string]: Partial<DeviceVariable> } = get(node, 'data.expandedVariables');
    const diagnosticVariable: Partial<DeviceVariable> = DiagnosticVariableColumn.getDiagnosticVariableByCategory(cellCategory, expandedVariables);
    const displayMode: DiagnosticVariableCellOptionsDisplayModeType = get(column, 'colDef.cellRendererParams.cellOptions.displayMode');

    if (!diagnosticVariable || !diagnosticVariable.lastValue) {
      return { type: displayMode, value: undefined };
    } else if (get(column, 'colDef.headerName') === 'UNIT') {
      return { type: 'unit', value: diagnosticVariable.unit };
    } else {
      return { type: displayMode, value: diagnosticVariable.lastValue[displayMode].toString() };
    }
  }
}
